// Shared subject-to-color mapping used across Timetable grid views.
export const SUBJECT_COLORS = {
  'Mathematics': 'bg-blue-100 text-blue-800 border-blue-200',
  'English': 'bg-emerald-100 text-emerald-800 border-emerald-200',
  'Science': 'bg-purple-100 text-purple-800 border-purple-200',
  'History': 'bg-amber-100 text-amber-800 border-amber-200',
  'Geography': 'bg-teal-100 text-teal-800 border-teal-200',
  'Art': 'bg-pink-100 text-pink-800 border-pink-200',
  'Mother Tongue': 'bg-orange-100 text-orange-800 border-orange-200',
  'Literature': 'bg-rose-100 text-rose-800 border-rose-200',
  'Physical Education': 'bg-lime-100 text-lime-800 border-lime-200',
  'Design': 'bg-cyan-100 text-cyan-800 border-cyan-200',
  'default': 'bg-slate-100 text-slate-700 border-slate-200',
};

export const getSubjectColor = (subject) => {
  for (const [key, value] of Object.entries(SUBJECT_COLORS)) {
    if (key !== 'default' && subject?.toLowerCase().includes(key.toLowerCase())) return value;
  }
  return SUBJECT_COLORS.default;
};

// Default time slots & break rows used by the weekly grids (matches backend schedule).
export const DEFAULT_TIME_SLOTS = [
  '07:30-08:10',
  '08:10-08:50',
  '08:50-09:30',
  '09:50-10:30',
  '10:30-11:10',
  '11:10-11:50',
  '12:20-13:00',
  '13:00-13:40',
];

// Break rows are inserted *before* period indexes 3 (Recess) and 6 (Lunch).
export const BREAK_INDEXES = { 3: 'Recess', 6: 'Lunch' };
